<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-23 10:41:16
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-31 09:36:32
-->
<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose"
  >
     <el-button @click="daochuData" v-if="codeData.indexOf('409') != -1" style="margin-bottom:24px" size="small"  type="primary">导出清单</el-button>
     <coententTable
              :columns="columns"
              :dataSource="dataSource"
              :loading="loading"
              :customSlot="customSlot"
              :y="500"
            >
            <template v-slot:cishu="scopeVal">
                 <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.num}}</div>
                  <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.num}}</div>
                <div style="color:rgba(245, 108, 108, 1)" v-if="scopeVal.scope.status == 2">{{scopeVal.scope.num}}</div>
            </template>
            <template v-slot:lastUpdateTime="scopeVal">
                 <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.lastUpdateTime}}</div>
                  <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.lastUpdateTime}}</div>
                <div style="color:rgba(245, 108, 108, 1)" v-if="scopeVal.scope.status == 2">{{scopeVal.scope.lastUpdateTime}}</div>
            </template>
            <template v-slot:columnName="scopeVal">
                <span v-if="scopeVal.scope.status == 0" :title="scopeVal.scope.allColumnName">{{scopeVal.scope.columnName}}</span>
                <span style="color:#E6A23C" v-if="scopeVal.scope.status == 1" :title="scopeVal.scope.allColumnName">{{scopeVal.scope.columnName}}</span>
                <span style="color:rgba(245, 108, 108, 1)" v-if="scopeVal.scope.status == 2" :title="scopeVal.scope.allColumnName">{{scopeVal.scope.columnName}}</span>
            </template>
            <template v-slot:status="scopeVal">
                <div v-if="scopeVal.scope.status == 0">合格</div>
                <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">警告</div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 2">不合格</div>
            </template>
             <template v-slot:type="scopeVal">
                <div v-if="scopeVal.scope.status == 0">
                   <div v-if="scopeVal.scope.type == 0">动态要闻</div>
                   <div v-if="scopeVal.scope.type == 1">通知公告</div>
                   <div v-if="scopeVal.scope.type == 2">政策文件</div>
                   <div v-if="scopeVal.scope.type == 3">政策解读</div>
                   <div v-if="scopeVal.scope.type == 4">其他栏目</div>
                </div>
                <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">
                   <div v-if="scopeVal.scope.type == 0">动态要闻</div>
                   <div v-if="scopeVal.scope.type == 1">通知公告</div>
                   <div v-if="scopeVal.scope.type == 2">政策文件</div>
                   <div v-if="scopeVal.scope.type == 3">政策解读</div>
                   <div v-if="scopeVal.scope.type == 4">其他栏目</div>
                </div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 2">
                   <div v-if="scopeVal.scope.type == 0">动态要闻</div>
                   <div v-if="scopeVal.scope.type == 1">通知公告</div>
                   <div v-if="scopeVal.scope.type == 2">政策文件</div>
                   <div v-if="scopeVal.scope.type == 3">政策解读</div>
                   <div v-if="scopeVal.scope.type == 4">其他栏目</div>
                </div>
            </template>
             <template v-slot:refreshCycle="scopeVal">
                <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.refreshCycle}}</div>
                <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.refreshCycle}}</div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 2">{{scopeVal.scope.refreshCycle}}</div>
            </template>
            </coententTable>
  </el-dialog>
</template>
<script >
import coententTable from "@/components/coentent_table.vue";
import {columnInfoList,exportColumnInfoList} from '../index';
export default {
  components:{
    coententTable
  },
  data() {
    return {
       columns: [
        {
          title: "序号",
          dataIndex: "num",
          ellipsis: true,
          width:80,
          scopedSlots: { customRender: "cishu" },
        },
        {
          title: "栏目名称",
          dataIndex: "columnName",
          ellipsis: true,
          width:300,
          scopedSlots: { customRender: "columnName" },
        },
        {
          title: "类型",
          dataIndex: "type",
          ellipsis: true,
           width:80,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "更新周期",
          dataIndex: "refreshCycle",
          ellipsis: true,
          width:180,
          scopedSlots: { customRender: "refreshCycle" },
        },
        {
          title: "最后一次更新",
          dataIndex: "lastUpdateTime",
          ellipsis: true,
           width:180,
          scopedSlots: { customRender: "lastUpdateTime" },
        },
        {
          title: "监测结果",
          dataIndex: "status",
          width:180,
          scopedSlots: { customRender: "status" },
          ellipsis: true,
        }
      ],
      customSlot: [
        {
          name: "status",
          customRender: "status",
        },
        {
          name: "lastUpdateTime",
          customRender: "lastUpdateTime",
        },
        {
          name: "columnName",
          customRender: "columnName",
        },
         {
          name: "cishu",
          customRender: "cishu",
        },
        {
          name: "type",
          customRender: "type",
        },
        {
          name: "refreshCycle",
          customRender: "refreshCycle",
        }
      ],
      dataSource: [],
      codeData:[],
      loading: false,
      dialogTitle:'',
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    itemData:{}
  },
  mounted() {
    this.getList()
    this.dialogTitle = `栏目不更新监测清单（${this.itemData.time}）`
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    getList(){
      this.loading = true;
      columnInfoList({
        siteId:sessionStorage.getItem('siteId'),
        time: this.itemData.time,
      }).then((res)=>{
          if(res.code == 0){
              this.dataSource = res.data;
              for (let index = 0; index <  this.dataSource.length; index++) {
                const element =  this.dataSource[index];
                element.num = index + 1;
              }
          }
          this.loading = false;
      })
    },
    daochuData(){
        exportColumnInfoList({
             siteId:sessionStorage.getItem('siteId'),
              time: this.itemData.time,
              fileName:'栏目不更新监测清单'
        }).then((res)=>{

        })
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog{
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
/deep/ .table{
  margin: 0px;
}
/deep/ .el-dialog__body{
  padding-top: 10px;
}
.el-button--primary {
  background: #176de6;
}
</style>
